module.exports = __webpack_public_path__ + "4227c7fc3d3643b1669bf6f8870d2ecf.svg";